import type { CountryIso } from "~/types"

const israelEligibleNationalities: CountryIso[] = [
  "ALB",
  "ASM",
  "AND",
  "AIA",
  "ARG",
  "ABW",
  "AUS",
  "AUT",
  "BRB",
  "BLR",
  "BEL",
  "BLZ",
  "BWA",
  "BVT",
  "BRA",
  "VGB",
  "BGR",
  "CAN",
  "CHL",
  "CXR",
  "CZE",
  "COL",
  "CRI",
  "HRV",
  "CUW",
  "CYP",
  "DNK",
  "DMA",
  "ECU",
  "SLV",
  "EST",
  "SWZ",
  "FJI",
  "FIN",
  "FRA",
  "GUF",
  "PYF",
  "GEO",
  "DEU",
  "GIB",
  "GRC",
  "GRL",
  "GRD",
  "GLP",
  "GUM",
  "GTM",
  "GGY",
  "HTI",
  "HND",
  "HKG",
  "HUN",
  "ISL",
  "IRL",
  "IMN",
  "ITA",
  "JAM",
  "JPN",
  "JEY",
  "LVA",
  "LSO",
  "LIE",
  "LTU",
  "LUX",
  "MWI",
  "MLT",
  "MTQ",
  "MUS",
  "MYT",
  "MEX",
  "MCO",
  "MNG",
  "MNE",
  "MSR",
  "NRU",
  "NCL",
  "NZL",
  "NIU",
  "NFK",
  "NOR",
  "PLW",
  "PAN",
  "PNG",
  "PRY",
  "PER",
  "POL",
  "PRT",
  "PRI",
  "ROU",
  "BLM",
  "KNA",
  "LCA",
  "SPM",
  "VCT",
  "WSM",
  "SMR",
  "SRB",
  "PSE",
  "SGP",
  "SVK",
  "SVN",
  "SLB",
  "ZAF",
  "ESP",
  "SUR",
  "SWE",
  "CHE",
  "TON",
  "TTO",
  "TCA",
  "TUV",
  "UKR",
  "WLF",
  "ESH",
  "ALA",
  "BHS",
  "BES",
  "CYM",
  "CCK",
  "COK",
  "DOM",
  "FLK",
  "FRO",
  "VUT",
  "MHL",
  "NLD",
  "MKD",
  "GBR",
  "MNP",
  "PHL",
  "RUS",
  "SHN",
  "MAF",
  "SXM",
  "ARE",
  "MAC",
  "FSM",
  "PCN",
  "REU",
  "TKL",
  "TWN",
  "KOR",
  "USA",
  "VIR",
  "URY"
];

export default israelEligibleNationalities;